import { IngredientContainProps } from './types';
import {
  Body3,
  Box,
  Heading5,
  Join,
  ListItem,
  Space,
  Strong,
  Text,
  UnorderedList,
} from '@gousto-internal/citrus-react';

const HARDCODED_ALLERGENS = [
  'almond',
  'almonds',
  'barley',
  'brazil nut',
  'brazil nuts',
  'cashew nut',
  'cashew nuts',
  'celeriac',
  'celery',
  'crustacean',
  'egg',
  'eggs',
  'fish',
  'hazelnut',
  'hazelnuts',
  'kamut',
  'lupin',
  'macadamia nuts',
  'macadamia nut',
  'macadamias',
  'milk',
  'mollusc',
  'molluscs',
  'mustard',
  'nuts',
  'oat',
  'oatmeal',
  'oats',
  'peanut',
  'peanuts',
  'pecan nut',
  'pecan nuts',
  'pecans',
  'pistachio nut',
  'pistachio nuts',
  'pistachios',
  'queensland nut',
  'rye',
  'sesame',
  'soy',
  'soya',
  'spelt',
  'sulphites',
  'sulphur dioxide',
  'walnut',
  'walnuts',
  'wheat',
];

export function IngredientsContain({ ingredients, recipeAllergens }: IngredientContainProps) {
  const highlightAllergens = (text: string, allergens: string[]) => {
    const combinedAllergens = [...allergens, ...HARDCODED_ALLERGENS];
    // Regex with word boundaries to match standalone allergens
    const allergenRegex = new RegExp(`\\b(${combinedAllergens.join('|')})\\b`, 'gi');
    return text
      .split(allergenRegex)
      .map((part, index) =>
        combinedAllergens.some((allergen) => allergen.toLowerCase() === part.toLowerCase()) ? (
          <Strong key={index}>{part}</Strong>
        ) : (
          part
        ),
      );
  };

  return (
    <Box data-testid="ingredients-contain">
      <Heading5>Ingredients contain</Heading5>
      <Space size={4} />
      <UnorderedList style={{ margin: 0, padding: 0 }}>
        <Join with={<Space size={6} />}>
          {ingredients.map((ingredient) => (
            <ListItem key={ingredient.name}>
              <Body3>
                <Strong>{ingredient.contains.label}:</Strong>{' '}
                <Text>
                  {' '}
                  {highlightAllergens(
                    ingredient.contains.subIngredientsString,
                    recipeAllergens,
                  )}{' '}
                </Text>
              </Body3>
            </ListItem>
          ))}
        </Join>
      </UnorderedList>
    </Box>
  );
}
